var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInterfaces(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.911,
    height: 21.498,
    viewBox: "0 0 43.911 21.498",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1200",
    "data-name": "Group 1200",
    transform: "translate(-414.967 -437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-import",
    transform: "translate(16101.236 23766.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.53,14.092H7.01c-4.91,0-7.01-2.1-7.01-7.01v-.13C0,2.512,1.75.372,5.67,0a.772.772,0,0,1,.82.68.751.751,0,0,1-.68.82c-3.14.29-4.31,1.77-4.31,5.46v.13c0,4.07,1.44,5.51,5.51,5.51h6.52c4.07,0,5.51-1.44,5.51-5.51v-.13c0-3.71-1.19-5.19-4.39-5.46a.748.748,0,1,1,.13-1.49c3.98.34,5.76,2.49,5.76,6.96V7.1C20.54,11.992,18.44,14.092,13.53,14.092Z",
    transform: "translate(-15686.27 -23322.842)",
    fill: "#ca1d2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M.75,14.38A.755.755,0,0,1,0,13.63V.75A.755.755,0,0,1,.75,0,.755.755,0,0,1,1.5.75V13.63A.749.749,0,0,1,.75,14.38Z",
    transform: "translate(-15676.75 -23329.75)",
    fill: "#ca1d2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M4.1,4.848a.742.742,0,0,1-.53-.22L.218,1.278A.75.75,0,0,1,1.278.218L4.1,3.037,6.918.218a.75.75,0,0,1,1.06,1.06l-3.35,3.35A.742.742,0,0,1,4.1,4.848Z",
    transform: "translate(-15680.098 -23319.098)",
    fill: "#ca1d2a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon-export",
    transform: "translate(16162.607 23767.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M13.53,14.092H7.01c-4.91,0-7.01-2.1-7.01-7.01v-.13C0,2.512,1.75.372,5.67,0a.772.772,0,0,1,.82.68.751.751,0,0,1-.68.82c-3.14.29-4.31,1.77-4.31,5.46v.13c0,4.07,1.44,5.51,5.51,5.51h6.52c4.07,0,5.51-1.44,5.51-5.51v-.13c0-3.71-1.19-5.19-4.39-5.46a.748.748,0,1,1,.13-1.49c3.98.34,5.76,2.49,5.76,6.96V7.1C20.54,11.992,18.44,14.092,13.53,14.092Z",
    transform: "translate(-15724.27 -23322.842)",
    fill: "#ca1d2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M.75,12.88A.755.755,0,0,1,0,12.13V.75A.755.755,0,0,1,.75,0,.755.755,0,0,1,1.5.75V12.13A.755.755,0,0,1,.75,12.88Z",
    transform: "translate(-15714.75 -23328.131)",
    fill: "#ca1d2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M7.448,4.847a.742.742,0,0,1-.53-.22L4.1,1.807l-2.82,2.82a.75.75,0,0,1-1.06-1.06L3.568.218a.754.754,0,0,1,1.06,0l3.35,3.35a.754.754,0,0,1,0,1.06A.725.725,0,0,1,7.448,4.847Z",
    transform: "translate(-15718.098 -23329.248)",
    fill: "#ca1d2a"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInterfaces);
export default __webpack_public_path__ + "static/media/Icon-interfaces.aff0c1af08875298135105e92fafb4db.svg";
export { ForwardRef as ReactComponent };